import React, { useState, useEffect } from 'react';

const Radnici = () => {
    const [radnici, setRadnici] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ 
        id: null, 
        ime: '', 
        prezime: '', 
        jmbg: '', 
        radno_mesto: '',
        cena_redovnog_sata: 0,
        cena_prekovremenog_sata: 0,
        cena_bolovanja: 0,
        cena_odmora: 0,
        cena_praznika: 0,
        cena_servisa: 0,
        cena_terenske_dnevnice: 0,
        cena_terenskog_dodatka: 0,
        cena_bonusa: 0,
        cena_toplog_obroka: 400,
        cena_toplog_obroka_dodatni: 450
    });
    const [sortConfig, setSortConfig] = useState({ key: 'ime', direction: 'asc' });

    const fetchRadnici = async () => {
        try {
            const res = await fetch('https://ecopell.ledscreen.rs/api/workers/?t=' + new Date().getTime());
            const data = await res.json();
            setRadnici(data);
            setLoading(false);
        } catch (err) { console.error("Greška pri učitavanju:", err); }
    };

    useEffect(() => { fetchRadnici(); }, []);

    const sortData = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedRadnici = [...radnici].sort((a, b) => {
        let valA = a[sortConfig.key] || '';
        let valB = b[sortConfig.key] || '';
        if (typeof valA === 'string') valA = valA.toLowerCase();
        if (typeof valB === 'string') valB = valB.toLowerCase();
        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEdit = !!formData.id;
        const url = isEdit 
            ? `https://ecopell.ledscreen.rs/api/workers/${formData.id}/`
            : 'https://ecopell.ledscreen.rs/api/workers/';

        const { id, ...dataWithoutId } = formData;

        const dataToSend = {
            ...dataWithoutId,
            cena_redovnog_sata: parseFloat(formData.cena_redovnog_sata) || 0,
            cena_prekovremenog_sata: parseFloat(formData.cena_prekovremenog_sata) || 0,
            cena_bolovanja: parseFloat(formData.cena_bolovanja) || 0,
            cena_odmora: parseFloat(formData.cena_odmora) || 0,
            cena_praznika: parseFloat(formData.cena_praznika) || 0,
            cena_servisa: parseFloat(formData.cena_servisa) || 0,
            cena_terenske_dnevnice: parseFloat(formData.cena_terenske_dnevnice) || 0,
            cena_terenskog_dodatka: parseFloat(formData.cena_terenskog_dodatka) || 0,
            cena_bonusa: parseFloat(formData.cena_bonusa) || 0,
            cena_toplog_obroka: parseFloat(formData.cena_toplog_obroka) || 0,
            cena_toplog_obroka_dodatni: parseFloat(formData.cena_toplog_obroka_dodatni) || 0
        };

        try {
            const response = await fetch(url, {
                method: isEdit ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dataToSend)
            });

            if (response.ok) {
                await fetchRadnici(); 
                setShowModal(false);
            } else {
                const errorData = await response.json();
                alert("Server javlja grešku: " + JSON.stringify(errorData));
            }
        } catch (err) { alert("Greška pri čuvanju podataka!"); }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Da li ste sigurni da želite da obrišete radnika?')) {
            const res = await fetch(`https://ecopell.ledscreen.rs/api/workers/${id}/`, { method: 'DELETE' });
            if (res.ok) fetchRadnici();
        }
    };

    if (loading) return <div style={{padding: '20px', color: 'white'}}>Učitavanje podataka...</div>;

    const commonStyle = { padding: '8px 5px', borderBottom: '1px solid #1a2a4a', boxSizing: 'border-box', fontSize: '12px' };
    const thBase = { ...commonStyle, color: '#3366ff', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer', backgroundColor: '#162447' };

    return (
        <div style={{padding: '20px', color: 'white'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <h2 style={{margin:0}}><i className="fas fa-users"></i> Radnici</h2>
                <button onClick={() => { setFormData({id:null, ime:'', prezime:'', jmbg:'', radno_mesto:'', cena_redovnog_sata:0, cena_prekovremenog_sata:0, cena_bolovanja:0, cena_odmora:0, cena_praznika:0, cena_servisa:0, cena_terenske_dnevnice:0, cena_terenskog_dodatka:0, cena_bonusa:0, cena_toplog_obroka:400, cena_toplog_obroka_dodatni:450}); setShowModal(true); }}
                        style={{backgroundColor: '#3366ff', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer'}}>
                    + Novi Radnik
                </button>
            </div>

            <div style={{overflowX: 'auto'}}>
                <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b', tableLayout: 'fixed'}}>
                    <thead>
                        <tr>
                            <th style={{...thBase, width: '40px'}} onClick={() => sortData('id')}>ID</th>
                            <th style={{...thBase, width: '130px'}} onClick={() => sortData('ime')}>Ime i Prezime</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_redovnog_sata')}>Red.</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_prekovremenog_sata')}>Prek.</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_toplog_obroka')}>T.O.</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_toplog_obroka_dodatni')}>T.O.D.</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_bolovanja')}>Bol.</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_odmora')}>Odm.</th>
                            <th style={{...thBase, width: '55px'}} onClick={() => sortData('cena_servisa')}>Serv.</th>
                            <th style={{...thBase, width: '75px'}} onClick={() => sortData('cena_terenske_dnevnice')}>T.Dnev.</th>
                            <th style={{...thBase, width: '70px'}} onClick={() => sortData('cena_terenskog_dodatka')}>T.Dod.</th>
                            <th style={{...commonStyle, textAlign: 'right', color: '#3366ff', width: '70px'}}>Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedRadnici.map(r => (
                            <tr key={r.id} style={{borderBottom: '1px solid #1a2a4a'}}>
                                <td style={commonStyle}>{r.id}</td>
                                <td style={commonStyle}>{r.ime} {r.prezime}</td>
                                <td style={commonStyle}>{r.cena_redovnog_sata}</td>
                                <td style={commonStyle}>{r.cena_prekovremenog_sata}</td>
                                <td style={commonStyle}>{r.cena_toplog_obroka}</td>
                                <td style={commonStyle}>{r.cena_toplog_obroka_dodatni}</td>
                                <td style={commonStyle}>{r.cena_bolovanja}</td>
                                <td style={commonStyle}>{r.cena_odmora}</td>
                                <td style={commonStyle}>{r.cena_servisa}</td>
                                <td style={commonStyle}>{r.cena_terenske_dnevnice}</td>
                                <td style={commonStyle}>{r.cena_terenskog_dodatka}</td>
                                <td style={{...commonStyle, textAlign: 'right'}}>
                                    <i className="fas fa-edit" style={{color: '#ffcc00', padding: '5px', cursor: 'pointer'}} 
                                       onClick={() => { setFormData(r); setShowModal(true); }}></i>
                                    <i className="fas fa-trash" style={{color: '#ff4d4d', padding: '5px', marginLeft: '5px', cursor: 'pointer'}} 
                                       onClick={() => handleDelete(r.id)}></i>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div style={{position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.85)', display:'flex', justifyContent:'center', alignItems:'center', zIndex:9999}}>
                    <div style={{backgroundColor:'#0a132b', padding:'25px', borderRadius:'10px', width:'650px', border:'1px solid #3366ff', maxHeight: '95vh', overflowY: 'auto'}}>
                        <h3 style={{marginTop: 0, color: 'white'}}>{formData.id ? 'Izmeni radnika' : 'Novi radnik'}</h3>
                        <form onSubmit={handleSubmit}>
                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
                                <div>
                                    <label style={labelStyle}>Ime i Prezime:</label>
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <input style={inputStyle} type="text" placeholder="Ime" value={formData.ime} onChange={e => setFormData({...formData, ime: e.target.value})} required />
                                        <input style={inputStyle} type="text" placeholder="Prezime" value={formData.prezime} onChange={e => setFormData({...formData, prezime: e.target.value})} required />
                                    </div>
                                    <label style={labelStyle}>JMBG i Radno Mesto:</label>
                                    <input style={inputStyle} type="text" placeholder="JMBG" value={formData.jmbg || ''} onChange={e => setFormData({...formData, jmbg: e.target.value})} />
                                    <input style={inputStyle} type="text" placeholder="Radno Mesto" value={formData.radno_mesto || ''} onChange={e => setFormData({...formData, radno_mesto: e.target.value})} />
                                    <label style={labelStyle}>Cena redovnog / prekovremenog:</label>
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <input style={inputStyle} type="number" step="0.01" value={formData.cena_redovnog_sata} onChange={e => setFormData({...formData, cena_redovnog_sata: e.target.value})} />
                                        <input style={inputStyle} type="number" step="0.01" value={formData.cena_prekovremenog_sata} onChange={e => setFormData({...formData, cena_prekovremenog_sata: e.target.value})} />
                                    </div>
                                    <label style={labelStyle}>Topli obrok (Standard / Dodatni):</label>
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <input style={inputStyle} type="number" step="0.01" value={formData.cena_toplog_obroka} onChange={e => setFormData({...formData, cena_toplog_obroka: e.target.value})} />
                                        <input style={inputStyle} type="number" step="0.01" value={formData.cena_toplog_obroka_dodatni} onChange={e => setFormData({...formData, cena_toplog_obroka_dodatni: e.target.value})} />
                                    </div>
                                </div>
                                <div>
                                    <label style={labelStyle}>Bolovanje / Odmor / Praznik:</label>
                                    <input style={inputStyle} type="number" step="0.01" placeholder="Bolovanje" value={formData.cena_bolovanja} onChange={e => setFormData({...formData, cena_bolovanja: e.target.value})} />
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <input style={inputStyle} type="number" step="0.01" placeholder="Odmor" value={formData.cena_odmora} onChange={e => setFormData({...formData, cena_odmora: e.target.value})} />
                                        <input style={inputStyle} type="number" step="0.01" placeholder="Praznik" value={formData.cena_praznika} onChange={e => setFormData({...formData, cena_praznika: e.target.value})} />
                                    </div>
                                    <label style={labelStyle}>Terenske naknade (Dnev / Dod):</label>
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <input style={inputStyle} type="number" step="0.01" value={formData.cena_terenske_dnevnice} onChange={e => setFormData({...formData, cena_terenske_dnevnice: e.target.value})} />
                                        <input style={inputStyle} type="number" step="0.01" value={formData.cena_terenskog_dodatka} onChange={e => setFormData({...formData, cena_terenskog_dodatka: e.target.value})} />
                                    </div>
                                    <label style={labelStyle}>Servis / Bonus:</label>
                                    <div style={{display:'flex', gap:'5px'}}>
                                        <input style={inputStyle} type="number" step="0.01" placeholder="Servis" value={formData.cena_servisa} onChange={e => setFormData({...formData, cena_servisa: e.target.value})} />
                                        <input style={inputStyle} type="number" step="0.01" placeholder="Bonus" value={formData.cena_bonusa} onChange={e => setFormData({...formData, cena_bonusa: e.target.value})} />
                                    </div>
                                </div>
                            </div>

                            <div style={{display:'flex', justifyContent:'flex-end', gap:'10px', marginTop:'15px'}}>
                                <button type="button" onClick={() => setShowModal(false)} style={{padding:'8px 15px', background:'none', color:'white', border:'none', cursor:'pointer'}}>Otkaži</button>
                                <button type="submit" style={{padding:'8px 15px', background:'#3366ff', color:'white', border:'none', borderRadius: '4px', cursor:'pointer'}}>Sačuvaj</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

const inputStyle = { width: '100%', padding: '8px', marginBottom: '8px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white', boxSizing: 'border-box', fontSize: '13px' };
const labelStyle = { color: '#3366ff', display: 'block', marginBottom: '3px', fontSize: '12px' };

export default Radnici;